<template>
    <div class="clinic-gardner">
        <b-button v-b-toggle="well._id">
            <div class="well-gardner">
                <span>{{ clinicGardnerLabel }}</span>
                <i class="fa fa-pencil select-button" />
            </div>
        </b-button>
        <edit-clinic-gardner-dialog :well="well" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EditClinicGardnerDialog from './EditClinicGardnerDialog'

export default {
    name: 'ClinicGardner',
    components: { EditClinicGardnerDialog },
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getClinicGardnerLabel: 'timelapse/getClinicGardnerLabel'
        }),
        clinicGardnerLabel() {
            return this.getClinicGardnerLabel(this.well.clinicGardner)
        }
    }
}
</script>

<style lang="scss">
.clinic-gardner {
    position: relative;
    cursor: pointer;

    .btn.btn-secondary.collapsed {
        background-color: transparent !important;
        width: 100%;
        border-radius: 4px;
        font-size: 10.5pt;
    }
    .btn.btn-secondary.not-collapsed {
        background-color: transparent !important;
        width: 100%;
        border-radius: 4px;
        font-size: 10.5pt;
    }

    .btn {
        .well-gardner {
            display: flex;
            justify-content: center;
            align-items: center;
            color: $light-3;

            .select-button {
                border: 0.1rem solid transparent;
                border-radius: 3px;
                padding: 7px;

                &:hover {
                    border-color: $light-3;
                }
            }
        }
    }

    .edit-clinic-gardner-dialog {
        position: absolute;
        right: -12px;
        top: 51px;
        z-index: 1;

        .card {
            border: 0.1rem solid $dark;
            border-radius: 4px;
            background: $dark-4;
            width: 215px;

            .card-body {
                padding: 0;
            }
        }
    }
}
</style>
